import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginComponent } from 'src/app/modules/settings/login/login/login.component';
import { TokenService } from 'src/app/shared/service/token.service'; // Adjust path if needed

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
})
export class NoAccessComponent {
  isLoggedIn: boolean;
  message: string;
  title: string;

  constructor(
    private tokenService: TokenService,
    private router: Router,
    public dialog: MatDialog
  ) {
    this.isLoggedIn = this.tokenService.getLogin();
    const navigation = this.router.getCurrentNavigation();
    const reason = navigation?.extras.state?.['reason'];
    // Display the appropriate message based on the reason
    if (reason === 'no-access') {//access denied
      this.title='no-access.title.access_denied'
      this.message = 'no-access.message.access_denied';
    } else {//invalid url
      this.title='no-access.title.not_found'
      this.message = 'no-access.message.not_found';
    }
  }
  redirectTo(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  showLogin() {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '476px',
      height: '571px',
      disableClose: false, //need to confirm
      autoFocus: false,
      panelClass: 'login-dialog-container',
      backdropClass: 'login-dialog-backdrop',
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
}
